import OurWorkHero from "./OurWorkHero";


function OurWork() {
    return (
        <>
            <OurWorkHero />

        </>
    );
}

export default OurWork;